import { render } from "./cc-visa.svg?vue&type=template&id=0914ed5e?inline"
const script = {}
script.render = render

export default script